import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Toast, ToastContainer } from 'react-bootstrap';

import { hideSnapshotToast } from '../../store/toasts';

const SnapshotToast = () => {
  const dispatch = useDispatch();
  const snapshotToastIsVisible = useSelector((store) => store.toasts.snapshotStarted);

  return (
    <ToastContainer position="top-center" style={{ position: 'fixed', zIndex: 1100 }}>
      <Toast
        onClose={() => dispatch(hideSnapshotToast())}
        show={snapshotToastIsVisible}
        bg="success"
        delay={2000}
        autohide
      >
        <Toast.Body className="text-white">Snapshot taking started in background</Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default SnapshotToast;
